/**
 * Anchor Scroll helper
 *
 */

const AnchorScroll = {
    vars: {
        topSelectors: [
            ".nav_wrapper",
            ".primary_nav_wrap",
            "#local-toggle",
            "#local-nav",
        ],
        buffer: 20,
        settleDelay: 150,
        maxAttempts: 4,
        tolerance: 4,
    },

    isVisible: function (element) {
        if (!element) {
            return false;
        }

        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();

        return (
            style.display !== "none" &&
            style.visibility !== "hidden" &&
            parseFloat(style.opacity || "1") !== 0 &&
            rect.height > 0 &&
            rect.width > 0
        );
    },

    isTopStickyElement: function (element) {
        if (!AnchorScroll.isVisible(element)) {
            return false;
        }

        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();

        if (rect.bottom <= 0) {
            return false;
        }

        if (style.position === "fixed") {
            return rect.top <= Math.min(window.innerHeight * 0.5, 320);
        }

        if (style.position !== "sticky") {
            return false;
        }

        const stickyTop = parseFloat(style.top);

        if (!Number.isFinite(stickyTop)) {
            return false;
        }

        return Math.abs(rect.top - stickyTop) <= AnchorScroll.vars.tolerance;
    },

    getOffset: function () {
        const elements = AnchorScroll.vars.topSelectors.flatMap((selector) =>
            Array.from(document.querySelectorAll(selector))
        );

        let maxBottom = 0;

        elements.forEach((element) => {
            if (!AnchorScroll.isTopStickyElement(element)) {
                return;
            }

            maxBottom = Math.max(
                maxBottom,
                element.getBoundingClientRect().bottom
            );
        });

        return Math.max(
            Math.ceil(maxBottom) + AnchorScroll.vars.buffer,
            AnchorScroll.vars.buffer
        );
    },

    scrollToAnchor: function (targetElement, onComplete, options) {
        if (!targetElement) {
            if (typeof onComplete === "function") {
                onComplete();
            }
            return;
        }

        let callback = onComplete;
        let scrollOptions = options || {};

        if (typeof onComplete === "object" && onComplete !== null) {
            scrollOptions = onComplete;
            callback = null;
        }

        const attempt = scrollOptions.attempt || 0;
        const maxAttempts =
            scrollOptions.maxAttempts ?? AnchorScroll.vars.maxAttempts;
        const behavior = attempt === 0 ? scrollOptions.behavior || "smooth" : "auto";
        const startY = window.scrollY;
        const targetPosition =
            targetElement.getBoundingClientRect().top +
            startY -
            AnchorScroll.getOffset();
        const distance = Math.abs(targetPosition - startY);
        const settleDelay =
            scrollOptions.delay ||
            (behavior === "smooth"
                ? Math.max(
                      AnchorScroll.vars.settleDelay,
                      Math.min(800, 250 + distance * 0.35)
                  )
                : AnchorScroll.vars.settleDelay);

        window.scrollTo({
            top: Math.max(targetPosition, 0),
            behavior,
        });

        window.setTimeout(function () {
            const targetTop = targetElement.getBoundingClientRect().top;
            const delta = targetTop - AnchorScroll.getOffset();

            if (
                attempt < maxAttempts &&
                Math.abs(delta) > AnchorScroll.vars.tolerance
            ) {
                AnchorScroll.scrollToAnchor(targetElement, callback, {
                    ...scrollOptions,
                    attempt: attempt + 1,
                    behavior: "auto",
                });
                return;
            }

            if (typeof callback === "function") {
                callback();
            }
        }, settleDelay);
    },
};

if (typeof window !== "undefined") {
    window.XtandiAnchorScroll = AnchorScroll;
}

export { AnchorScroll };
